var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgButtonOptimize = function SvgButtonOptimize(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12.83 12.83",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "button_optimize")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.19,7.19a.88.88,0,0,0-1.09.6A4.77,4.77,0,0,1,5.81,11a4.82,4.82,0,0,1-4-5.55A4.75,4.75,0,0,1,5,1.74.91.91,0,0,0,5.62.56.88.88,0,0,0,4.4.09,6.55,6.55,0,0,0,6.62,12.83a6.41,6.41,0,0,0,1.1-.09,5.44,5.44,0,0,0,1.13-.33,6.5,6.5,0,0,0,3.91-4A.88.88,0,0,0,12.19,7.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,1.7a5.64,5.64,0,0,1,1.16.56,4.84,4.84,0,0,1,1.93,2.5.89.89,0,0,0,1.15.59.85.85,0,0,0,.53-1.12A6.45,6.45,0,0,0,8.55.05.85.85,0,0,0,7.43.88.83.83,0,0,0,8,1.7Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButtonOptimize, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/button_optimize.3ab02796.svg";
export { ForwardRef as ReactComponent };